import React from "react";
import { FormattedMessage } from "react-intl";

import * as notesServiceApi from "../api/notesServiceApi";
import { notify, notifyError } from "./notificationsActions";
import * as types from "../constants/ActionTypes";

export const fetchCurrentNoteGrants = id => dispatch => {
  return notesServiceApi
    .fetchCurrentNoteGrants(id)
    .then(grants => {
      dispatch({
        type: types.FETCH_CURRENT_NOTE_GRANTS,
        grants
      });
    })
    .catch(() => {
      dispatch(
        notifyError({
          message: (
            <FormattedMessage
              defaultMessage="Failed to fetch grants for this note"
              id="fetchGrantsFailure"
            />
          )
        })
      );
    });
};

export const updateCurrentNoteGrants = (id, grants) => dispatch => {
  return notesServiceApi
    .updateCurrentNoteGrants(id, grants)
    .then(() => {
      dispatch(
        notify({
          message: (
            <FormattedMessage
              defaultMessage="You have successfully shared the note"
              id="shareNoteSuccess"
            />
          ),
          type: "success"
        })
      );
    })
    .catch(() => {
      dispatch(
        notifyError({
          message: (
            <FormattedMessage
              defaultMessage="Failed to share the note"
              id="shareNoteFailure"
            />
          )
        })
      );
    });
};

export const resetGrants = () => dispatch => {
  dispatch({
    type: types.RESET_GRANTS
  });
};
